<template>
  <ConfirmationModal
    bodyText=""
    continueText="confirm"
    :headerText="errorHeader"
    :mainActionAttention="true"
  >
    <div :class="$style.errorContent">
      {{ errorText }}
    </div>
  </ConfirmationModal>
</template>

<script>
import ConfirmationModal from 'client/components/Modal/ModalComponents/ConfirmationModal.vue';

export default {
  name: 'ScimTestErrorModal',

  components: {
    ConfirmationModal,
  },

  props: {
    error: {
      type: String,
      default: '',
    },
    errorText: {
      type: String,
      default: '',
    },
  },
  computed: {
    errorHeader() {
      return `${this.error} - Error Details`;
    },
  },
};
</script>

<style module>
  .errorContent {
    max-height: 247px;
    overflow: auto;
  }
</style>
